export default __webpack_public_path__ + "static/therapist-220869a06b2ea4a6b2d4c3091a30a45a.webp";